// extracted by mini-css-extract-plugin
export default {"root":"StaticBar_root__13ZFm","score":"StaticBar_score__2Akbx","idle":"StaticBar_idle__B7m9o","orange":"StaticBar_orange__0q1wk"};